import logo from './logo.svg';
import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Best from './components/Best'
import Featured from './components/Featured'
import Footer from './components/Footer';
import CarouselCard from './components/CarouselCard';



function App() {
  return (
    <div>
      <Navbar/>
      <Hero />
      <Best />
      <Featured/>
      <section id="Thingstodo" className="Thingstodo">
          {/* <h1>Learning</h1> */}
          <div className="carousel-container">
            <CarouselCard />
          </div>
        </section>
      <Footer/>
    </div>
  );
}

export default App;
